module.exports = __webpack_public_path__ + "static/img/243242.a5c12cfb.png";